import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function AdminRoute() {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="loading-screen">Loading...</div>;
  if (user && user.isAdmin) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
}
